import Pulse from '@ubisend/pulse-boost';

Pulse.render();
